import { type ReactElement, type SVGProps } from 'react';

export const MailIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 5H3V19H21V5ZM4 6.37962V6H20V6.3744L12 12L4 6.37962ZM4 7.61499V18H20V7.61013L12.0003 13.2356L4 7.61499Z"
        fill="currentColor"
      />
    </svg>
  );
};
